import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Terminal from "@/pages/Terminal";
import Operacoes from "@/pages/Operacoes";
import Infraestrutura from "@/pages/Infraestrutura";
import Cabotagem from "@/pages/Cabotagem";
import Grupo from "@/pages/Grupo";
import Contato from "@/pages/Contato";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-ops-base text-white antialiased overflow-x-hidden">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terminal" element={<Terminal />} />
            <Route path="/operacoes" element={<Operacoes />} />
            <Route path="/infraestrutura" element={<Infraestrutura />} />
            <Route path="/cabotagem" element={<Cabotagem />} />
            <Route path="/grupo" element={<Grupo />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" richColors position="top-right" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
